/**
 * <ModalContent
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//

import SearchList from 'components/UI/SearchList'

class ModalContent extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      onSelect,
      showName,
    } = this.props;

    return (
      <SearchList {...this.props} onSelect={onSelect} showName={showName} />
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/SelectItem/ModalContent.js